import axios from 'axios';
import { AUTH_URL, DOMAIN_URL } from '../../constants/url';

const axiosInstance = axios.create({
  baseURL: DOMAIN_URL,
});

const handleLogout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userName');
  localStorage.removeItem('userId');
  
  window.location.href = '/login';
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response, // Return the response if successful
  async (error) => {
    const { response, config } = error;

    // If a 401 error occurs, handle it (Unauthorized access)
    if (response && (response.status === 401 || response.status === 403)) {
      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        try {
          const refreshResponse = await axios.post(`${AUTH_URL}/refresh`, refreshToken);

          const newAccessToken = refreshResponse.data.accessToken;
          const newRefreshToken = refreshResponse.data.refreshToken;

          localStorage.setItem('accessToken', newAccessToken);
          localStorage.setItem('refreshToken', newRefreshToken);

          config.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axios(config);
        } catch (refreshError) {
          // localStorage.removeItem('accessToken');
          // localStorage.removeItem('refreshToken');
          handleLogout();
          return Promise.reject(refreshError);
        }
      } else {
        handleLogout();
        return Promise.reject(new Error('No refresh token available'));
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
